module.exports = __webpack_public_path__ + "static/prticle-top-right-7008d66665bf1da1d452b7f43dd0a814.png";